// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"348":"group-default","970":"group-component"}[chunkId] + "." + {"348":"42dad230","970":"e3e5b780"}[chunkId] + ".css";
};